import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const EvTariffInformation = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/ev-tariff-information-revamp/components/EvTariffInformationContent'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/ev-tariff-information-revamp/components/EvTariffInformationHeader'
      )
  ),
  Footer: lazy(
    () =>
      import(
        'components/direct-sales/ev-tariff-information-revamp/components/EvTariffInformationFooter'
      )
  )
};

export default EvTariffInformation;
